import type { VoidFunctionComponent } from 'react';

import type { DependencyLicense } from '../../../../../shared/types/licenses';

import styles from '../LicenseDrawer.module.less';

type Props = {
  licenseText: DependencyLicense['licenseText'];
};

const GlobalLicenseTextTab: VoidFunctionComponent<Props> = ({ licenseText }) => {
  return (
    <>
      <div className={styles.title}>Full License Text</div>
      <pre className={styles.licenseText}>{licenseText}</pre>
    </>
  );
};

export default GlobalLicenseTextTab;
